import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetCashtagSuggestionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetCashtagSuggestionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getCashtagSuggestion = (request: GetCashtagSuggestionRequest, options?: CashRequestOptions) =>
  post<GetCashtagSuggestionRequest, GetCashtagSuggestionResponse>('/2.0/cash/get-cashtag-suggestion', request, {
    ...options,
    rejectOnError: true,
  })
